import React from 'react';
import { usePersonality } from '../../contexts/PersonalityContext';
import styles from './PersonalitySelector.module.css';

export const PersonalitySelector = () => {
  const { personalities, selectedPersonality, setSelectedPersonality, loading } = usePersonality();

  if (loading || !personalities.length) return null;

  return (
    <div className={styles.container}>
      <select
        className={styles.select}
        value={selectedPersonality}
        onChange={(e) => setSelectedPersonality(e.target.value)}
        aria-label="Select news personality"
      >
        {personalities.map((personality) => (
          <option key={personality.id} value={personality.id}>
            {personality.name}
          </option>
        ))}
      </select>
    </div>
  );
}; 